import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetosuratcab() {



  const cardData = {
"keyword": "Pune to Surat Cab",

"headingDescription":
  "Shivai Travels offers reliable and comfortable Pune to Surat Cab service for travelers seeking safe, affordable, and convenient long-distance transportation. Whether you are traveling for business meetings, textile industry visits, family trips, tourism, or corporate travel, our taxi service ensures a smooth and stress-free journey. With experienced drivers, clean air-conditioned vehicles, and transparent pricing with no hidden charges, we provide a dependable travel experience from Pune to Surat. Our fleet includes sedans, SUVs, Innova cars, and premium vehicles suitable for solo travelers, families, and corporate clients. With flexible one-way and round-trip options, doorstep pickup, easy cab booking, and 24/7 customer support, Shivai Travels ensures comfortable and timely travel between Pune and Surat.",

"topPlaces": [
  {
    "title": "Dumas Beach",
    "description":
      "Dumas Beach is one of Surat’s most famous coastal attractions known for its black sand and relaxing seaside atmosphere. Travelers using Pune to Surat cab service often visit this beach for leisure and evening outings."
  },
  {
    "title": "Science Centre Surat",
    "description":
      "Science Centre Surat is a popular educational and entertainment destination featuring science exhibits, a planetarium, and an art gallery. Cab travelers from Pune enjoy visiting this family-friendly attraction."
  },
  {
    "title": "Sarthana Nature Park",
    "description":
      "Sarthana Nature Park is a zoo and green recreational space in Surat ideal for wildlife lovers and families. Pune to Surat taxi service provides convenient access to this peaceful destination."
  },
  {
    "title": "Dutch Garden",
    "description":
      "Dutch Garden is a historic garden in Surat known for colonial architecture and landscaped greenery. Travelers booking Pune to Surat cabs often include this heritage attraction in their itinerary."
  },
  {
    "title": "Ambika Niketan Temple",
    "description":
      "Ambika Niketan Temple is a well-known religious site in Surat dedicated to Goddess Ambika. Taxi from Pune to Surat offers comfortable travel for devotees and tourists."
  },
  {
    "title": "Gopi Talav",
    "description":
      "Gopi Talav is a scenic lake and recreation area in Surat featuring boating and entertainment facilities. Pune to Surat cab booking is ideal for family outings and leisure visits."
  },
  {
    "title": "VR Surat Mall",
    "description":
      "VR Surat Mall is one of the city’s major shopping and entertainment destinations offering retail stores, restaurants, and cinemas. Travelers from Pune often visit this modern mall during their trip."
  },
  {
    "title": "ISKCON Temple Surat",
    "description":
      "ISKCON Temple Surat is a peaceful spiritual destination known for devotional activities and beautiful temple architecture. Pune to Surat cab service ensures convenient access for pilgrims."
  },
  {
    "title": "Tapi Riverfront",
    "description":
      "Tapi Riverfront is a scenic riverside area in Surat ideal for evening walks and relaxing views. Cab travelers from Pune enjoy spending leisure time at this attraction."
  },
  {
    "title": "Snow Park Surat",
    "description":
      "Snow Park Surat is an indoor entertainment attraction offering snow-themed activities and fun experiences. Pune to Surat taxi service makes it easy for families and children to visit this exciting destination."
  }
],



services: [
  {
    name: "Pune to Surat Cab",
    description: "Pune to Surat cab service provides reliable long-distance transportation between Pune and Surat with comfortable vehicles and experienced drivers. Vehicles are suitable for highway travel ensuring smooth and safe journeys for families, tourists, and business travelers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Surat. Vehicles include sedans, SUVs, Innova Crysta, Ertiga, and premium taxis suitable for different travel requirements. Flexible booking options allow convenient one-way and round-trip cab reservations."
  },
  {
    name: "Pune to Surat Taxi",
    description: "Pune to Surat taxi service offers dependable transportation for passengers traveling between Pune and Surat with professional chauffeurs and comfortable vehicles. Vehicles provide spacious seating and smooth highway travel suitable for business trips, tourism, and family journeys. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Surat. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Cab from Pune to Surat",
    description: "Cab from Pune to Surat service provides comfortable intercity transportation for passengers traveling for business, tourism, and family visits. Vehicles ensure reliable highway travel with experienced chauffeurs offering safe and smooth journeys. Pickup services are available from residential areas, offices, hotels, railway stations, and airports across Pune and Surat. Ideal for one-way and round-trip travel requirements. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Taxi from Pune to Surat",
    description: "Taxi from Pune to Surat service offers reliable transportation with comfortable vehicles and professional drivers for long-distance travel between Pune and Surat. Vehicles provide smooth highway travel suitable for tourism, business meetings, and family trips. Professional drivers ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Surat. Flexible booking options allow easy taxi reservations."
  },
  {
    name: "Pune to Surat Cab Service",
    description: "Pune to Surat cab service provides dependable transportation solutions for passengers traveling between Pune and Surat with comfortable vehicles and experienced chauffeurs. Vehicles are suitable for highway travel ensuring safe and smooth journeys for individuals, families, and corporate travelers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Surat. Ideal for business travel, tourism, and family trips. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Pune to Surat Taxi Fare",
    description: "Pune to Surat taxi fare service provides transparent pricing information for passengers planning intercity travel between Pune and Surat. Travelers can estimate transportation costs based on vehicle type, travel distance, and trip requirements. Comfortable vehicles ensure smooth highway travel with professional drivers offering safe transportation services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Surat. Flexible booking options allow convenient fare estimation and taxi reservations."
  },
  {
    name: "Pune to Surat One Way Cab",
    description: "Pune to Surat one way cab service provides economical transportation for passengers traveling from Pune to Surat without return travel requirements. Comfortable vehicles ensure smooth highway travel suitable for business trips, tourism, and family visits. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune and Surat including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient one-way cab reservations."
  },
  {
    name: "Pune to Surat Round Trip Taxi",
    description: "Pune to Surat round trip taxi service offers convenient return transportation for passengers planning travel between Pune and Surat. Comfortable vehicles provide smooth highway journeys with experienced drivers ensuring safe and reliable transportation services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Surat. Ideal for business travel, tourism, and family trips. Flexible booking options allow convenient round-trip taxi reservations."
  },
  {
    name: "Pune to Surat Cab Booking",
    description: "Pune to Surat cab booking service allows passengers to reserve comfortable intercity transportation between Pune and Surat. Vehicles include sedans, SUVs, luxury cars, Innova Crysta, and premium taxis suitable for different passenger requirements. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Surat. Flexible booking options allow instant and advance cab reservations."
  },
  {
    name: "Cheap Pune to Surat Cab",
    description: "Cheap Pune to Surat cab service provides affordable transportation between Pune and Surat with comfortable vehicles and economical pricing. Vehicles ensure reliable highway travel suitable for tourism, business travel, and family journeys. Professional drivers ensure safe driving and timely pickup services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune and Surat. Flexible booking options allow convenient low-cost cab reservations."
  },
  {
    name: "Best Pune to Surat Taxi",
    description: "Best Pune to Surat taxi service offers premium transportation with comfortable vehicles and professional chauffeurs for smooth intercity travel. Vehicles provide spacious seating, luggage capacity, and reliable highway performance suitable for business travel, tourism, and family trips. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Surat. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Sedan Pune to Surat Cab",
    description: "Sedan Pune to Surat cab service offers economical and comfortable transportation for solo travelers, couples, and small families traveling between Pune and Surat. Sedan vehicles provide smooth highway travel with comfortable seating and luggage space suitable for intercity journeys. Professional drivers ensure punctual pickup and safe driving services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune and Surat. Flexible booking options allow convenient sedan cab reservations."
  },
  {
    name: "SUV Pune to Surat Taxi",
    description: "SUV Pune to Surat taxi service provides spacious transportation for families and groups traveling between Pune and Surat. SUV vehicles offer comfortable seating, luggage capacity, and smooth highway performance suitable for long-distance journeys. Professional chauffeurs ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Surat. Flexible booking options allow convenient SUV taxi reservations."
  },
  {
    name: "Innova Pune to Surat Cab",
    description: "Innova Pune to Surat cab service provides premium SUV transportation for passengers seeking comfortable and reliable intercity travel. Innova vehicles offer spacious seating, smooth ride quality, and luggage space suitable for business travel, tourism, and family trips. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune and Surat. Flexible booking options allow convenient Innova cab reservations."
  },
  {
    name: "Long Distance Cab Pune Surat",
    description: "Long distance cab Pune Surat service offers dependable transportation for passengers traveling between Pune and Surat with comfortable vehicles and experienced chauffeurs. Vehicles ensure smooth highway travel suitable for business trips, tourism, and family travel requirements. Professional drivers ensure safe driving and reliable transportation services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Surat. Flexible booking options allow convenient long-distance cab reservations."
  },
  {
    name: "Pune to Vadodara Cab Service",
    description: "Pune to Vadodara cab service provides reliable transportation between Pune and Vadodara with comfortable vehicles and professional chauffeurs. Vehicles ensure smooth highway travel suitable for business journeys, tourism, and family trips. Professional drivers ensure safe driving and timely pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Vadodara. Flexible booking options allow convenient one-way and round-trip cab reservations."
  }
],

tableData: [
  ["Pune to Surat Cab", "Pune to Surat Taxi"],
  ["Cab from Pune to Surat", "Taxi from Pune to Surat"],
  ["Pune to Surat Cab Service", "Pune to Surat Taxi Fare"],
  ["Pune to Surat One Way Cab", "Pune to Surat Round Trip Taxi"],
  ["Pune to Surat Cab Booking", "Cheap Pune to Surat Cab"],
  ["Best Pune to Surat Taxi", "Sedan Pune to Surat Cab"],
  ["SUV Pune to Surat Taxi", "Innova Pune to Surat Cab"],
  ["Long Distance Cab Pune Surat", "Pune to Vadodara Cab Service"]
],



 whychoose: [
      {
        WhyChooseheading: "Reliable Pune to Surat Cab Service",
        WhyChoosedescription: "Shivai Travels provides reliable Pune to Surat cab service with professional drivers, comfortable vehicles, and punctual pickup for smooth and safe interstate travel."
      },
      {
        WhyChooseheading: "Affordable Pune to Surat Taxi Fare",
        WhyChoosedescription: "Shivai Travels offers affordable Pune to Surat cab pricing with transparent fare details and no hidden charges. Customers receive complete fare information before confirming their booking."
      },
      {
        WhyChooseheading: "24/7 Surat Cab Service Availability",
        WhyChoosedescription: "Our Pune to Surat cab service operates 24 hours a day for business travel, family trips, textile market visits, airport transfers, and emergency transportation requirements."
      },
      {
        WhyChooseheading: "Comfortable & Clean AC Cabs",
        WhyChoosedescription: "All taxis provided by Shivai Travels are fully air-conditioned, sanitized, and regularly maintained to provide comfortable long-distance travel experiences for passengers."
      },
      {
        WhyChooseheading: "One Way & Round Trip Cab Booking",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including one-way Pune to Surat taxi service, round-trip bookings, business tours, and customized travel packages."
      },
      {
        WhyChooseheading: "Wide Range of Cab Vehicle Options",
        WhyChoosedescription: "Customers can choose from sedan taxis, Ertiga, Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for individuals, families, business travelers, and group tours."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, offices, hotels, Pune Airport, railway stations, and all major Pune areas including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Interstate Travel",
        WhyChoosedescription: "Our experienced drivers are familiar with Pune to Surat highway routes and ensure safe driving, smooth travel, and timely arrival for every interstate journey."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune to Surat cab service?", answer: "Pune to Surat cab service provides comfortable taxi transportation between Pune and Surat for business travel, family trips, and interstate journeys." },
    { question: "Is Pune to Surat cab service available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 Pune to Surat cab service." },
    { question: "Which vehicles are available for Pune to Surat travel?", answer: "Shivai Travels offers sedan taxis, Ertiga, Innova, Innova Crysta, and Tempo Travellers." },
    { question: "Can I book a one-way cab from Pune to Surat?", answer: "Yes, customers can book one-way as well as round-trip Pune to Surat taxi services." },
    { question: "Do you provide airport pickup and drop services?", answer: "Yes, Shivai Travels provides airport transfer services along with interstate cab bookings." },
    { question: "Are all Pune to Surat taxis air-conditioned?", answer: "Yes, all taxis are fully air-conditioned and maintained for comfortable long-distance travel." },
    { question: "Can I book Pune to Surat cab service online?", answer: "Yes, customers can easily book Pune to Surat cab service online or through phone booking." },
    { question: "Do you provide cabs for family and business travel?", answer: "Yes, Shivai Travels provides comfortable vehicles suitable for family tours and corporate travel." },
    { question: "Are Pune to Surat cab fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Pune to Surat cab service?", answer: "Yes, advance booking is available and recommended for long-distance travel and holiday seasons." }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Mr. Rajesh Mehta",
      feedback:
        "Booked Pune to Surat cab service with Shivai Travels. Comfortable vehicle, experienced driver, and smooth interstate travel experience.",
      rating: 5
    },
    {
      id: 2,
      name: "Mrs. Priyanka Shah",
      feedback:
        "Excellent Pune to Surat taxi service. Affordable pricing, punctual pickup, and very reliable customer support.",
      rating: 5
    }
  ];































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Surat Cab Service",
  "image": "https://shivaitravels.com/assets/images/pune-to-surat-cab.jpg",
  "description": "Book Pune to Surat cab service for safe and comfortable long-distance travel. Shivai Travels offers affordable one-way and round-trip taxi booking with sedan, SUV, Innova, and luxury cab options available 24x7 for intercity routes.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/pune-to-surat-cab"
  }
};






  return (
    <div>

<Helmet>
  <title>Pune to Surat Cab Service | Affordable Long Distance Taxi | +91 9689815477</title>

  <meta
    name="description"
    content="Book Pune to Surat cab service for one-way and round trip travel. Affordable taxi options including sedan, SUV, Innova, and luxury cabs available 24x7 for safe intercity journeys."
  />

  <meta
    name="keywords"
    content="pune to surat cab, pune to surat taxi, cab from pune to surat, taxi from pune to surat, pune to surat cab service, pune to surat taxi fare, pune to surat one way cab, pune to surat round trip taxi, pune to surat cab booking, cheap pune to surat cab, best pune to surat taxi, sedan pune to surat cab, suv pune to surat taxi, innova pune to surat cab, long distance cab pune surat, Pune to Surat Cab, Pune to Surat Cab Service, Pune to Surat Taxi Service, Pune to Surat Cab Booking, Best Pune to Surat Cab, One Way Pune to Surat Cab, Round Trip Pune to Surat Taxi, Cheap Pune to Surat Cab, 24x7 Pune to Surat Cab Service, Outstation Cab Pune to Surat, Pune to Vadodara Cab, Pune to Vadodara Cab Service, Pune to Vadodara Taxi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/29.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetosuratcab;